import Vue from 'vue';
import Component from 'vue-class-component';
import BasketTable from '../BasketTable/BasketTable';
import { updateProductCountOpts, addProductToBasketOpts } from '@/types/basket';
import xlsLoad from '@/api/xlsLoad';
import { Product } from '@/api/product';
import { modalParams } from '@/types/state.modal';

@Component({
    components: {
        BasketTable
    }
})
export default class BasketAbstract extends Vue {
    xlsLoading = false
    xlsError = ''
    async xlsLoad(e: Event) {
        this.xlsError = ''
        let inp: HTMLInputElement = e.target as HTMLInputElement
        if (!inp.files || !inp.files[0].name.match(/\.xlsx?/gm)) {
            this.xlsError = 'Неправильный формат файла'
            return false
        }
        let file = inp.files[0]
        this.xlsLoading = true
        try {
            let data = await xlsLoad(file)
            data.body && data.body.forEach(sProduct => {
                this.$store.dispatch('addProductToBasket', <addProductToBasketOpts>{
                    quiet: true,
                    product: new Product(sProduct),
                })
            });

            let mParams: modalParams = {
                type: 'success',
                msg: data.msg ? data.msg : ''
            }
            this.$store.commit('modal:open', mParams)

        } catch (error) {
            this.xlsError = error.message
            let mParams: modalParams = {
                type: 'error',
                msg: error.message
            }
            this.$store.commit('modal:open', mParams)
        }
        inp.value = ''
        this.xlsLoading = false
    }
}